import './CRUDBuyer.scss';
import Component from './CRUDBuyer.js';
export default Component;
